import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

export const AbstractDropdownItemStatic = styled.div(tw`
  leading-snug
  px-2
  py-1
  text-base
  text-primary-medium
  text-left
  w-full

  // Borders are used instead of margins to increase the click area as
  // much as possible
  bg-clip-padding
  border-b-[4px]
  border-t-[4px]
  border-transparent
`);
